<template>
    <b-container class="pb-3">
        <b-row>
            <b-col>
                <h2>Details zur Ferienwohnung</h2>
                <div class="line-wrapper"><span class="line"></span></div>

                <b-list-group>
                    <b-list-group-item class="flex-column align-items-start" v-for="item in details" :key="item.title">
                        <div class="d-flex w-100">
                            <h5 class="mb-1" v-html="item.title"></h5>
                        </div>
                        <div v-html="item.details"></div>
                    </b-list-group-item>
                </b-list-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'Details',
  data: () => ({
    details: [
      { title: 'Gesamtfläche / Max. Personen', details: '48m&sup2; über 2 Stockwerke für maximal 5 Personen, 2 Erwachsene und bis zu 3 Kinder' },
      { title: 'Schlafzimmer - 1. Stock &#9702; 12m&sup2;', details: 'Doppelbett (200x180), Einzelbett (190x90), Kleiderschrank, SAT TV, Ganzkörperspiegel, Bettvorleger, verstellbare Bettgestelle, Verdunklung möglich' },
      { title: 'Wohn-/Schlafzimmer - 1. Stock &#9702; 9m&sup2;', details: 'Schlafsofa (190x140), großer Wäscheschrank, Staubsauger' },
      { title: 'Wohn-Küche', details: 'Radio, TV SAT, 4-Plattenherd Ceran-Kochfeld, Geschirrspüler, Kaffeemaschine, Küchenzeile, Kühlschrank, Mikrowelle, Toaster' },
      { title: 'Badezimmer', details: 'Dusche, Föhn, Waschbecken, WC' },
      { title: 'Terrasse &#9702; 8m&sup2;', details: 'Gartenmöbel, Holzkohlegrill, Pool (Mitbenutzung), Sonnenschirm' },
      { title: 'Annex', details: 'Vermietung von Mai bis Oktober' },
      { title: 'Allgemein', details: 'Parkplatz, Warmes Wasser, Waschmaschine, Zentralheizung, Sandkasten, Kinderschaukel, Turnstange' },
      { title: 'Nicht gestattet', details: 'Haustiere, Rauchen im Haus' },
      { title: 'Geeignet für', details: 'Familienurlaub, Langzeiturlaub, Nichtraucher, Urlaub mit Baby' }
    ]
  })
}
</script>
